export default "__VITE_ASSET__Czuoh1HF__"